import { render, staticRenderFns } from "./LContact.vue?vue&type=template&id=6e4101ef&scoped=true&"
import script from "./LContact.vue?vue&type=script&lang=js&"
export * from "./LContact.vue?vue&type=script&lang=js&"
import style0 from "./LContact.vue?vue&type=style&index=0&id=6e4101ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4101ef",
  null
  
)

export default component.exports